var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomSparkles = function SvgCustomSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.448 13.726a1.361 1.361 0 0 0 .898 1.288l4.452 1.638 1.637 4.45a1.373 1.373 0 0 0 2.576 0l1.642-4.445 4.449-1.638a1.372 1.372 0 0 0 0-2.576l-4.452-1.638-1.638-4.45a1.373 1.373 0 0 0-2.575 0l-1.638 4.453-4.448 1.638a1.36 1.36 0 0 0-.903 1.28Zm4.826-8.277H8.895v1.38a.69.69 0 1 1-1.379 0v-1.38H6.137a.69.69 0 0 1 0-1.38h1.38V2.69a.69.69 0 1 1 1.378 0v1.38h1.38a.69.69 0 1 1 0 1.38ZM2.69 8.208h.69v-.69a.69.69 0 1 1 1.378 0v.69h.69a.69.69 0 0 1 0 1.38h-.69v.689a.69.69 0 1 1-1.379 0v-.69h-.69a.69.69 0 0 1 0-1.38Z",
    fill: "currentColor"
  })));
};

export default SvgCustomSparkles;